import React from 'react'
import { PhoneInput } from 'react-international-phone'

const PhoneInputWrapper = React.forwardRef((props, ref) => (
  <div className='form-group row'>
    <label className={`control-label col-lg-${props.labelColSize}`} htmlFor='phone'>Phone</label>
    <div className={`col-lg-${props.inputColSize}`}>
      <PhoneInput
        innerRef={ref}
        defaultCountry='us'
        value={props.phone}
        className='phone-input-wrapper'
        inputClassName='form-control'
        error={true}
        inputProps={{
          name: 'phone',
          id: 'phone'
        }}
        onChange={(phone, country) => props.onChange(phone, country)}
      />
    </div>
  </div>
))

export default PhoneInputWrapper
